import "./activity-modal.css";

/**
 * LF360-1881 — one field of the activity panel: what it is, then the thing
 * itself.
 *
 * The panel used to be a two-column form, and every screen that drew a field had
 * to hand-set the label's width and pull the control back with a negative margin
 * to make the two columns line up. Stacking them is the design's answer and it
 * takes those decisions away from the call site: a field is a label and a
 * control, and they line up because there is only one edge.
 */
export const ActivityField = ({ label, htmlFor, className = "", children }) => (
  <div className={className ? `activity-field ${className}` : "activity-field"}>
    {label ? (
      htmlFor ? (
        <label className="activity-field__label" htmlFor={htmlFor}>
          {label}
        </label>
      ) : (
        <p className="activity-field__label">{label}</p>
      )
    ) : null}
    {children}
  </div>
);

/**
 * The filled box a control sits in.
 *
 * antd's own border and background are turned off at the call site
 * (`variant="borderless"`), so this is the only thing drawing one. That is what
 * keeps a select, a time picker and a plain read-only value the same height
 * instead of three — which is the whole reason the old panel was full of inline
 * widths.
 */
export const ActivityControl = ({ className = "", children }) => (
  <div className={className ? `activity-control ${className}` : "activity-control"}>
    {children}
  </div>
);

export default ActivityField;
